import { Box, LinearProgress } from "@material-ui/core";
import { FunctionComponent } from "react";

interface ProfileStatusProps {
  percentage: number
  hideAvatar?: boolean
  primaryBar?: boolean
  companyBar?: boolean
  marginRight?: string
}

export const ProfileStatusBar: FunctionComponent<ProfileStatusProps> = ({ percentage, hideAvatar, primaryBar, companyBar, marginRight }) => {
  return (
    <Box display="flex" flexDirection="row" width="100%" mt=".50em">
      <Box alignSelf="center" mr={companyBar ? "0" : marginRight || "0.5em"} width="100%">
        <LinearProgress
          style={{
            width: hideAvatar ? '100%' : '150px',
            color: 'black'
          }}
          color={(percentage > 50 && !primaryBar) ? 'secondary' : 'primary'}
          variant="determinate"
          value={percentage}
        />
      </Box>
    </Box>
  )
}
